import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { NavigationBlock } from '@cbridge-tools/navigation-block';
import { LpNavigationItem } from './navigationItem/LpNavigationItem';
import { lpSubNavigationPropsSelector } from './LpSubNavigation.selector';

export const LpSubNavigation: FunctionComponent = () => {
  const { t } = useTranslation();

  const { items, isLoading } = useSelector(lpSubNavigationPropsSelector);

  return (
    <NavigationBlock
      header={t('text:navigation.config.settings.lps')}
      items={items}
      isLoading={isLoading}
      NavigationItemComponent={LpNavigationItem}
    />
  );
};
